import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ApiError, tinctApi } from '../../api';
import { invalidatePageQueries } from '../pages/invalidate-page-queries';

export type DeleteBuyerParams = {
  buyerId: string;
};

export const deleteBuyer = async (
  params: DeleteBuyerParams,
): Promise<void> => {
  return await tinctApi.buyers.deleteBuyer(params.buyerId);
};

export const useDeleteBuyer = (
  options?: Omit<
    UseMutationOptions<void, ApiError, DeleteBuyerParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteBuyer,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ['buyers'],
      });
      queryClient.removeQueries({
        queryKey: ['buyer', args[1].buyerId],
      });
      // The backend drops the logo from every page of the workspace showing it
      // before answering, so every cached page is stale now, whichever
      // campaign it belongs to. The re-match job it also starts per affected
      // campaign only refills the freed slots; the studio watches that job for
      // its own campaign (useLogoRematch).
      void invalidatePageQueries(queryClient);
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
